import { getConfidenceChipClasses } from "../utils";

type ConfidenceChipProps = {
  confidence: number;
};

const ConfidenceChip = ({ confidence }: ConfidenceChipProps) => {
  if (!confidence) return null;

  return <span className={`tw-inline-flex tw-items-center tw-rounded-[10px] tw-border tw-px-[9px] tw-py-[1px] tw-text-sm ${getConfidenceChipClasses(confidence)}`}>{Math.round(confidence)}%</span>;
};

export default ConfidenceChip;
